import { Card } from "@/components/ui/card";
import { ProfileCompleteItem } from "./profile-complete-item";

export const ProfileCompleteCard = ({
    items,
    totalAmount,
    amountCompleted,
}) => {
    return (
        <Card size="lg">
            <h2 className="mb-3 text-xl font-semibold">
                Your profile isn't live yet
            </h2>
            <p className="mb-4 text-neutral-500">
                Patients can't find you in search until every section below is
                complete. Finish these and you'll go live automatically.
            </p>
            <div>
                <div className="flex">
                    <p>Profile completion</p>
                    <p className="ms-auto font-medium">
                        {amountCompleted}/{totalAmount}
                    </p>
                </div>
                <div className="mt-1 h-2 w-full rounded-full bg-neutral-200">
                    <div
                        className="h-2 rounded-full bg-darkgreen-500"
                        style={{
                            width: `calc(${amountCompleted} / ${totalAmount} * 100%)`,
                        }}
                    ></div>
                </div>
            </div>
            <div className="mt-3 divide-y divide-gray-200">
                {items?.map((item) => {
                    return (
                        <ProfileCompleteItem
                            key={item.id}
                            complete={item.complete}
                            title={item.title}
                            link={item.link}
                        />
                    );
                })}
            </div>
        </Card>
    );
};
